/**
 * Quick-add to cart from product cards
 * Handles quantity +/- buttons and add-to-cart via Shopify AJAX API
 */
(function () {
  document.addEventListener("click", function (e) {
    // Quantity minus
    var minusBtn = e.target.closest("[data-qa-minus]");
    if (minusBtn) {
      e.preventDefault();
      e.stopPropagation();
      var input = minusBtn
        .closest(".product-card-quick-add__qty")
        .querySelector("[data-qa-qty]");
      var val = parseInt(input.value, 10) || 1;
      if (val > 1) input.value = val - 1;
      return;
    }

    // Quantity plus
    var plusBtn = e.target.closest("[data-qa-plus]");
    if (plusBtn) {
      e.preventDefault();
      e.stopPropagation();
      var input = plusBtn
        .closest(".product-card-quick-add__qty")
        .querySelector("[data-qa-qty]");
      var val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
      return;
    }

    // Add to cart
    var addBtn = e.target.closest("[data-qa-add]");
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();

      var form = addBtn.closest(".product-card-quick-add__form");
      var variantSelect = form.querySelector("[data-qa-variant-select]");
      var variantId;
      if (!variantSelect) {
        variantId = addBtn.getAttribute("data-variant-id");
      } else if (variantSelect.tagName === "SELECT") {
        variantId = variantSelect.value;
      } else {
        var activeBtn = variantSelect.querySelector(
          ".product-card-quick-add__size-btn.is-active",
        );
        variantId = activeBtn
          ? activeBtn.getAttribute("data-variant-id")
          : addBtn.getAttribute("data-variant-id");
      }
      var qtyInput = form.querySelector("[data-qa-qty]");
      var quantity = parseInt(qtyInput.value, 10) || 1;

      addBtn.disabled = true;
      var origText = addBtn.textContent;
      addBtn.textContent = "...";

      var didSucceed = false;

      fetch(window.routes.cart_add_url + ".js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          id: parseInt(variantId, 10),
          quantity: quantity,
        }),
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw err;
            });
          }
          return res.json();
        })
        .then(function () {
          didSucceed = true;
          addBtn.textContent = "Added!";
          addBtn.classList.add("product-card-quick-add__btn--added");
          // Dispatch updateCart to refresh cart counter
          document.dispatchEvent(
            new CustomEvent("updateCart", {
              bubbles: true,
              detail: {
                callback: function () {},
              },
            }),
          );
          setTimeout(function () {
            addBtn.textContent = origText;
            addBtn.disabled = false;
            addBtn.classList.remove("product-card-quick-add__btn--added");
          }, 2000);
        })
        .catch(function (err) {
          console.error("Quick-add error:", err);
          if (err && err.description) {
            addBtn.textContent = err.description;
          } else {
            addBtn.textContent = "Not enough stock";
          }
        })
        .finally(function () {
          if (!didSucceed) {
            setTimeout(function () {
              addBtn.textContent = origText;
              addBtn.disabled = false;
            }, 2500);
          }
        });
    }
  });

  // Size button selection
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".product-card-quick-add__size-btn");
    if (!btn) return;
    var container = btn.closest("[data-qa-variant-select]");
    container
      .querySelectorAll(".product-card-quick-add__size-btn")
      .forEach(function (b) {
        b.classList.remove("is-active");
      });
    btn.classList.add("is-active");
    // update the add button's variant id
    var addBtn = btn
      .closest(".product-card-quick-add__form")
      .querySelector("[data-qa-add]");
    if (addBtn)
      addBtn.setAttribute(
        "data-variant-id",
        btn.getAttribute("data-variant-id"),
      );
    // update stock display
    var card = btn.closest(".product-card-quick-add");
    var stockEl = card && card.querySelector("[data-qa-stock]");
    if (stockEl) {
      var inv = parseInt(btn.getAttribute("data-inventory"), 10) || 0;
      var label = btn.textContent.trim();
      stockEl.textContent = inv + " in stock (" + label + ")";
      stockEl.classList.toggle("product-card-quick-add__stock--low", inv <= 5);
    }
  });

  // Variant select change — update stock count display (legacy select fallback)
  document.addEventListener("change", function (e) {
    var select = e.target.closest("[data-qa-variant-select]");
    if (!select) return;
    var card = select.closest(".product-card-quick-add");
    var stockEl = card.querySelector("[data-qa-stock]");
    if (!stockEl) return;
    var opt = select.options[select.selectedIndex];
    var inv = parseInt(opt.getAttribute("data-inventory"), 10) || 0;
    var variantTitle = opt.textContent
      .replace(/\s*\(\d+ left\)\s*$/, "")
      .trim();
    var isDefault =
      select.closest(".product-card-quick-add") &&
      select.options.length === 1 &&
      variantTitle === "Default Title";
    stockEl.textContent =
      inv + " in stock" + (isDefault ? "" : " (" + variantTitle + ")");
    stockEl.classList.toggle("product-card-quick-add__stock--low", inv <= 5);
  });
})();
